module.exports = __webpack_public_path__ + "media/images/flags/1x1/dza-593d2b962c7d086a6b71fc01ff4a84ad.svg";